import React, { useContext, useEffect, useMemo } from "react";

import StyledBanner from "../components/BannerComponents/StyledBanner";
import Banner from "../components/BannerComponents/Banner";
import BannerBG from "../components/BannerComponents/BannerBG";
import RoomsList from '../components/SearchResults/RoomsList';

import Container from '@mui/material/Container';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Paper, Typography } from "@mui/material";

import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { SearchContext } from "../context/SearchContext";
import { UserContext } from "../context/UserContext";
import { paramsToObj } from "../services/router-utils";


const SelectedHotel = (props) => {
  const searchContext = useContext(SearchContext);
  const userContext = useContext(UserContext);
  const { selectedHotel: hotel, getHotel, getHotelPrice, roomPrices, refreshQuery } = searchContext
  const [ searchParams ] = useSearchParams();
  const query = useMemo(() => paramsToObj(searchParams), [searchParams]);

  useEffect(() => {
    console.info(`Refreshed query: ${query}`)
    refreshQuery(query)
  }, [query, refreshQuery]);

  const { id } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  }

  // get hotel description
  useEffect(() => {
    const fetchInfo = async () => {
      const hotelInfo = await getHotel(id);
      console.log(`Fetched hotel: ${hotelInfo.id}`)
    };
    fetchInfo(); 

  }, [id, getHotel]);

  useEffect(() => {
    const fetchPrices = async () => {
      getHotelPrice(id, query);
    }
    fetchPrices();
  }, [getHotelPrice, id, query])

  return (
    <>
      <BannerBG bannerBG='roomsBannerBG'>
        <StyledBanner img={ hotel.image }>
          <Banner title={`${hotel.info.name}`}>
            <Button onClick={handleBack} variant="contained">Back to search</Button>
          </Banner>
        </StyledBanner>
      </BannerBG>
        <Container sx={{
          display: 'flex',
          justifyContent: "center"
        }}>
          <Box sx={{
            minWidth: 400,
            width: "90%",
            maxWidth: 1000,
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}>
            <Box id="description" >
              <Typography variant="h4" sx={{mb:1}}>
                Hotel overview
              </Typography>
              <Paper dangerouslySetInnerHTML={{__html: hotel.info.description}}
              sx={{px:5, py:2}}/>
            </Box>
            <Box id="rooms">
              <Typography variant="h5">
                Rooms
              </Typography>
              <RoomsList canBook={userContext.isLoggedIn} hidden={!hotel.info.completed} rooms={roomPrices ? roomPrices.rooms : []}/>
            </Box>
            <Box id="location">
              <Typography variant="h5">
                Location
              </Typography>
              {hotel.info.address}
            </Box>
          </Box>
        </Container>
    </>
  )
}

export default SelectedHotel;
